//import { Button, ButtonType } from '@nx-frontend/shared/ui/button';
import { useTranslations } from 'next-intl';
import classNames from 'classnames';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { getBgClassNames, getTextClassNames } from '@nx-frontend/shared/themes';
import { PortalBgType, PortalTextType, ThemeColorSchemas } from '@nx-frontend/shared/types';

interface EmptyStateProps {
  themeColors: ThemeColorSchemas;
}
export function EmptyState({ themeColors }: EmptyStateProps) {
  const t = useTranslations('files_dashboard');
  return (
    <div className="flex flex-col items-center justify-center w-full p-6 gap-6 mt-8">
      <div
        className={classNames(
          'flex flex-col items-center justify-center rounded-md text-center py-8 w-[40%]',
          getBgClassNames(themeColors, PortalBgType.SURFACE_DISABLE)
        )}
      >
        <Icon icon={IconsMap.FILE_BOX} className="w-16 h-16" />
        <p className={classNames('font-medium text-sm pt-2', getTextClassNames(themeColors, PortalTextType.SURFACE))}>
          gif/video/image
        </p>
      </div>
      <div className="flex flex-col items-center justify-center text-center gap-2">
        <h2 className={classNames('text-2xl font-bold', getTextClassNames(themeColors, PortalTextType.SURFACE))}>
          {t('files_dashboard-empty_dashboard')}
        </h2>
        <p className={classNames('text-[12px]', getTextClassNames(themeColors, PortalTextType.SURFACE))}>
          {t('files_dashboard-empty_dashboard_description')}
          {/*  Click here to easily upload and share files in our
          dedicated team space. */}
        </p>
        {/* <div className="mt-1 flex flex-col md:flex-row md:space-x-4">
          <div className="p-1">
            <Button type={ButtonType.FLAT} onClick={() => console.log('Upload files')}>
              <Icon icon={IconsMap.UPLOAD} className="w-4 h-4 mr-2" />
              <span>Upload files</span>
            </Button>
          </div>
          <div className="p-1">
            <Button type={ButtonType.BASIC} onClick={() => console.log('Learn more')}>
              <span>Learn more</span>
            </Button>
          </div>
        </div> */}
      </div>
    </div>
  );
}
